import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import axios from 'axios'
import { API_REPORT_URL, API_VERSION_1, API_SETTING_URL } from '@/.env'
import { getItemByLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'

export default class TippingService extends BaseService {
  static async getTippingSummary (query, store, storeId) {
    store.commit('common/SET_LOADING', true)
    try {
      const response = await axios.get(`${API_REPORT_URL}/${API_VERSION_1}/stores/${storeId || getItemByLocalStorage(localStorageKey.STORE_ID)}/tipping-summary`, {
        params: {
          page: query.page,
          limit: 100,
          mode: query.mode || 'DATE',
          timeZone: query.timeZone,
          orderCreatedAtMin: query.createdAtMin,
          orderCreatedAtMax: query.createdAtMax,
          outletIds: query.outletIds ? (query.outletIds || []).join(',') : query.outletIds,
          registerIds: query.registerIds ? (query.registerIds || []).join(',') : query.registerIds,
          salesmen: query.salemen ? (query.salemen || []).join(',') : query.salemen
        }
      })
      if (response.data.items) {
        const data = response.data
        store.commit('common/SET_LOADING', false)
        return new ResponseWrapper(response, data)
      } else {
        store.commit('common/SET_LOADING', false)
      }
    } catch (error) {
      store.commit('common/SET_LOADING', false)
      throw new ErrorWrapper(error, error.message)
    }
  }

  static async getTippingTransaction (query, store, storeId, isExportExcel = false) {
    store.commit('common/SET_LOADING', true)
    try {
      const response = await axios.get(`${API_REPORT_URL}/${API_VERSION_1}/stores/${storeId || getItemByLocalStorage(localStorageKey.STORE_ID)}/tipping-transaction`, {
        params: {
          page: query.page,
          limit: query.limit,
          mode: query.mode || 'DATE',
          timeZone: query.timeZone,
          orderByType: 'DESC',
          orderCreatedAtMin: query.createdAtMin,
          orderCreatedAtMax: query.createdAtMax,
          outletIds: query.outletIds ? (query.outletIds || []).join(',') : query.outletIds,
          registerIds: query.registerIds ? (query.registerIds || []).join(',') : query.registerIds,
          salesmen: query.salemen ? (query.salemen || []).join(',') : query.salemen
        }
      })
      if (response.data.items) {
        const data = response.data
        store.commit('common/SET_LOADING', false)
        return new ResponseWrapper(response, data)
      } else {
        store.commit('common/SET_LOADING', false)
      }
    } catch (error) {
      store.commit('common/SET_LOADING', false)
      throw new ErrorWrapper(error, error.message)
    }
  }

  static async getUsers (payload, store, storeId) {
    try {
      const response = await axios.get(`${API_SETTING_URL}/${API_VERSION_1}/stores/${storeId || getItemByLocalStorage(localStorageKey.STORE_ID)}/users`, {
        params: {
          page: payload.page,
          limit: 100
        }
      })
      if (response.data.items) {
        const data = response.data
        return new ResponseWrapper(response, data)
      } else {
        store.commit('common/SET_LOADING', false)
      }
    } catch (error) {
      throw new ErrorWrapper(error, error.message)
    }
  }
}
